import { render, staticRenderFns } from "./PersonPerformanceConfirmEdit.vue?vue&type=template&id=037a3839&scoped=true&"
import script from "./PersonPerformanceConfirmEdit.vue?vue&type=script&lang=js&"
export * from "./PersonPerformanceConfirmEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037a3839",
  null
  
)

export default component.exports